@if (showE2eToggle()) {
  <andor-expansion-panel [(expanded)]="panelExpanded" [icon]="faShieldHalved">
    <span panel-title>{{ 'End-to-end encryption' | translate }}</span>

    <andor-mat-toggle-wrapper
      label="{{ 'Use end-to-end encryption' | translate }}"
      tooltipText="{{
        'Generates a private room password used to encrypt voice and chat. The password is added to the invite link so people you share it with can join. Anyone without the link cannot decrypt the room.'
          | translate
      }}">
      <mat-slide-toggle (toggleChange)="toggleE2e()" [checked]="e2eEnabled()"></mat-slide-toggle>
    </andor-mat-toggle-wrapper>

    @if (showPasswordField()) {
      <andor-text-field
        [formControl]="passwordControl"
        [type]="passwordInputType()"
        [placeholder]="'Room Password' | translate"
        [labelTooltip]="
          'This password is added to the invite link so people you share it with can decrypt the room. Anyone without the link cannot join.'
            | translate
        "
        [inlineActions]="creatorActions()"
        [errorMessages]="passwordErrors()"
        showErrorOn="dirty"
        [label]="'Password' | translate"></andor-text-field>
    }
  </andor-expansion-panel>
} @else if (readonlyState(); as state) {
  <div class="stored-key">
    <fa-icon [icon]="faShieldHalved"></fa-icon>
    <span>
      @switch (state) {
        @case ('stored') {
          {{ 'End-to-end encrypted — key saved on this device' | translate }}
        }
        @case ('encrypted') {
          {{ 'End-to-end encrypted' | translate }}
        }
        @default {
          {{ 'Not end-to-end encrypted' | translate }}
        }
      }
    </span>
    @if (state === 'stored') {
      <button
        type="button"
        class="stored-key__copy"
        [andorTooltip]="'Copy password' | translate"
        [attr.aria-label]="'Copy password' | translate"
        (click)="copyStoredPassword()">
        <fa-icon [icon]="faCopy"></fa-icon>
      </button>
    }
  </div>
  <p class="fixed-hint">
    {{ 'Encryption is fixed when a room is created. To change it, create a new room.' | translate }}
  </p>
} @else if (showStoredIndicator()) {
  <div class="stored-key">
    <fa-icon [icon]="faShieldHalved"></fa-icon>
    <span>{{ 'End-to-end encrypted — key saved on this device' | translate }}</span>
    <button
      type="button"
      class="stored-key__copy"
      [andorTooltip]="'Copy password' | translate"
      [attr.aria-label]="'Copy password' | translate"
      (click)="copyStoredPassword()">
      <fa-icon [icon]="faCopy"></fa-icon>
    </button>
  </div>
} @else if (showPasswordField()) {
  <andor-text-field
    [formControl]="passwordControl"
    [type]="passwordInputType()"
    [placeholder]="'Room Password' | translate"></andor-text-field>
  @if (rejection(); as reason) {
    <p class="password-rejection" role="alert">
      @if (reason === 'invalid') {
        {{ 'Wrong password. Check it and try again.' | translate }}
      } @else {
        {{ 'This room requires a password.' | translate }}
      }
    </p>
  }
}
